module.exports = __webpack_public_path__ + "static/img/929_phase_function_Paper_PointsHejduk_Prediction.9df0ef8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/929_phase_function_Paper_PointsHejduk_Prediction.png
// module id = F/XL
// module chunks = 0